export default function LogoMark({ size = 36, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      className={`logo-mark ${className}`.trim()}
    >
      <defs>
        <linearGradient id="lm-tile" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#102842" />
          <stop offset="1" stopColor="#050d1a" />
        </linearGradient>
        <linearGradient id="lm-m" x1="8" y1="8" x2="40" y2="42" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#9af6ee" />
          <stop offset=".55" stopColor="#2af0e4" />
          <stop offset="1" stopColor="#009d95" />
        </linearGradient>
        <radialGradient id="lm-glow" cx="24" cy="6" r="28" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00C2B8" stopOpacity=".35" />
          <stop offset="1" stopColor="#00C2B8" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="lm-shine" x1="0" y1="0" x2="0" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffffff" stopOpacity=".22" />
          <stop offset=".5" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Tile */}
      <rect width="48" height="48" rx="13" fill="url(#lm-tile)" />
      <rect width="48" height="48" rx="13" fill="url(#lm-glow)" />
      <rect width="48" height="48" rx="13" fill="url(#lm-shine)" />
      <rect x="0.75" y="0.75" width="46.5" height="46.5" rx="12.25" fill="none" stroke="rgba(0,194,184,.32)" strokeWidth="1.2" />

      {/* Geometric filled M */}
      <path
        d="M9 38 L9 11 Q9 9.5 10.5 9.5 L13.5 9.5 Q14.7 9.5 15.4 10.5 L24 22.5 L32.6 10.5 Q33.3 9.5 34.5 9.5 L37.5 9.5 Q39 9.5 39 11 L39 38 L33 38 L33 21 L26.4 30.4 Q25.6 31.5 24 31.5 Q22.4 31.5 21.6 30.4 L15 21 L15 38 Z"
        fill="url(#lm-m)"
      />

      {/* Droplet accent in the V */}
      <path
        d="M24 33.5 C24 33.5 21.6 36.5 21.6 38.6 Q21.6 41 24 41 Q26.4 41 26.4 38.6 C26.4 36.5 24 33.5 24 33.5 Z"
        fill="#ffffff"
      />
      <circle cx="23.2" cy="38.4" r="0.55" fill="rgba(0,194,184,.7)" />

      {/* Sparkle */}
      <path
        d="M40.5 5.5 L41 7.4 L42.9 7.9 L41 8.4 L40.5 10.3 L40 8.4 L38.1 7.9 L40 7.4 Z"
        fill="#ffffff"
      />
    </svg>
  );
}
